import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="megamenu-collapse"
export default class extends Controller {
  connect () {
    this.element.querySelectorAll('.navbar-collapse-link').forEach(toggle => {
      toggle.addEventListener('click', this.preventDropdownClose)
    })
  }

  preventDropdownClose(event) {
    event.stopPropagation()
  }
}
